import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class AdminOrderApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANAGEMENT_ORDER);
  }

  // billing address
  getBillingAddress(orderId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${orderId}/billing-address`,
    );
  }

  updateBillingAddress(orderId, data) {
    return this.httpClient.put(
      `${this.getResourceUrl()}${orderId}/billing-address`,
      data,
    );
  }

  // shipping address
  getShippingAddress(orderId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${orderId}/shipping-address`,
    );
  }

  updateShippingAddress(orderId, data) {
    return this.httpClient.put(
      `${this.getResourceUrl()}${orderId}/shipping-address`,
      data,
    );
  }
}

export default new AdminOrderApi();
